
import React, { useEffect, useRef, useState } from "react"
import { FaChevronDown, FaChevronRight } from "react-icons/fa"
import MegaMenuExpanded from "./mega-menu-expanded"
import { megaMenu, megaMenuHover, navButton } from './mega-menu.module.css'
import { dataLayer, trackEvent } from "../../modules/analytics"

const MegaMenu = ({ desks }) => {

  const [activeTab, setActiveTab] = useState(desks[0].id);
  const [showMore, setShowMore] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    function handleOutsideClick(event) {
      if (menuRef.current && !menuRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
        setShowMore(false);
      }
    }

    if (showMore) {
      document.addEventListener('click', handleOutsideClick);
    }

    return () => document.removeEventListener('click', handleOutsideClick);
  }, [showMore]);

  return (
    <>
      <div className={`${megaMenu} ${showMore && megaMenuHover}`}
      // onMouseOver={() => handleMouseOver()}
      // onMouseLeave={() => handleMouseLeave()}
      >
        <div className={navButton} ref={buttonRef} onClick={() => {
          setShowMore(prevState => !prevState);
          trackEvent('nav_megamenu_open')
        }}>
          <span>Meer</span> {showMore ? <FaChevronDown /> : <FaChevronRight />}
        </div>
        {showMore && (
          <MegaMenuExpanded clickRef={menuRef} activeTab={activeTab} setActiveTab={setActiveTab} desks={desks} />
        )}
      </div>
    </>
  )
}

export default MegaMenu
